export const ACCEPTABLE_FILES =
  '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpg,image/jpeg,.pdf,application/pdf';

export const MAX_FILE_SIZE = 5242880; // 5MB in bytes
